import { VCDA_ERROR } from '../actions/types';

export default function vcdaError(state = null, action) {
	switch (action.type) {
		case VCDA_ERROR:
			return { error: action.payload.error };
		// no default
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/vcdaError.js